<script lang='jsx'>
// styles:
import 'muse-ui/es5/theme/index.js'
// import 'muse-ui/src/styles/base.less'
import 'muse-ui/dist/muse-ui.css'

// libs:
import Vue from 'vue'

// images:
import img1 from '../img/activities/IMG_20260413_111832.jpg'
import img2 from '../img/activities/IMG_20260413_111933.jpg'
import img3 from '../img/activities/IMG_20260413_112132.jpg'
import img4 from '../img/activities/IMG_20260413_112244.jpg'
import qrcode1 from '../img/qrcode_xeshop.jpg'

// components:
import Header from './components/home-header.vue'
import Footer from './components/home-footer.vue'

// additional Muse UI components
import {
  Card,
  Avatar,
  Icon,
  Divider,
  Button,
} from 'muse-ui'
import router from './router.js'

export default {
  data () {
    return {
      ts: Date.now()
    }
  }
  ,router
  ,render () {
    const APPBAR_HEIGHT = 64
    return (
      <main class='home-page'>
        {/* Fixed App Bar */}
        <Header class='header'
          title='脑洞英语课堂'
          height={APPBAR_HEIGHT}
        />

        {/* Hero Section with background image */}
        <section class='hero-section' style={{
          backgroundImage: 'url(//7dn.naodongenglish.com/www/deskchair.jpeg)',
          minHeight: `calc(100vh - ${APPBAR_HEIGHT}px)`,
          marginTop: `${APPBAR_HEIGHT}px`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.4)',
          }}></div>
          <div style={{
            position: 'relative',
            color: 'white',
            textAlign: 'center',
            textShadow: '0 1px 2px black',
            padding: '2em',
          }}>
            <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5em' }}>英语教师的互助成长教研中心</h1>
          </div>
        </section>

        {/* About Us Section */}
        <section class='about-section' style={{ padding: '4em 1em', textAlign: 'center' }}>
          <h2 style={{ fontWeight: '300', marginBottom: '1em' }}>ABOUT US</h2>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '100%', maxWidth: '960px' }}>
              <Divider style={{ margin: '1em auto', width: '60px', height: '2px', backgroundColor: '#a72028' }} />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '100%', maxWidth: '960px' }}>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#555' }}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto cupiditate sint possimus quidem atque harum excepturi nemo velit tempora! Enim inventore fuga, qui ipsum eveniet facilis obcaecati corrupti asperiores nam
              </p>
            </div>
          </div>
        </section>

        {/* What We Do Section */}
        <section class='what-we-do' style={{ padding: '4em 1em', backgroundColor: '#f5f5f5' }}>
          <h2 style={{ textAlign: 'center', fontWeight: '300' }}>WHAT WE DO</h2>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '100%', maxWidth: '960px' }}>
              <Divider style={{ margin: '1em auto', width: '60px', height: '2px', backgroundColor: '#a72028' }} />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2em', flexWrap: 'wrap' }}>
            {[
              { icon: 'mdi-account-group', title: 'COMMUNITY', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto cupiditate sint possimus quidem atque harum excepturi nemo velit tempora!' },
              { icon: 'mdi-book-open-variant', title: 'RESOURCES', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto cupiditate sint possimus quidem atque harum excepturi nemo velit tempora!' },
              { icon: 'mdi-lightbulb-on', title: 'TOPICS', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto cupiditate sint possimus quidem atque harum excepturi nemo velit tempora!' },
            ].map((item, idx) => (
              <div key={idx} style={{ padding: '1em', width: '100%', maxWidth: '380px' }}>
                <Card style={{ textAlign: 'center', height: '100%' }}>
                  <div style={{ padding: '2em 1em 1em' }}>
                    <Avatar color='#a72028' size={88} style={{ margin: '0 auto' }}>
                      <Icon value={item.icon} size={36} color='white' />
                    </Avatar>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '0.5em', padding: '0 1em' }}>
                    <h3 style={{ fontWeight: '300' }}>{item.title}</h3>
                  </div>
                  <div style={{ textAlign: 'left', color: '#666', padding: '0 1.5em 1.5em' }}>
                    {item.text}
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </section>

        {/* Statistics Parallax Section */}
        <section class='stats-section' style={{
          backgroundImage: 'url(//7dn.naodongenglish.com/www/blackboard.jpg)',
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          textShadow: '0 2px 4px black',
        }}>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
            {[
              { key: 'Teachers', result: '5W+' },
              { key: 'Resource', result: '1W+' },
              { key: 'Topics', result: '3K+' },
            ].map((stat, idx) => (
              <div key={idx} style={{ textAlign: 'center', padding: '2em', width: '100%', maxWidth: '360px' }}>
                <div style={{ fontSize: '3rem', fontWeight: 'bold' }}>{stat.result}</div>
                <div style={{ fontSize: '1.2rem', marginTop: '0.5em', fontWeight: '300' }}>{stat.key}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Seen Before Section */}
        <section class='seen-before' style={{ padding: '4em 1em' }}>
          <h2 style={{ textAlign: 'center', fontWeight: '300' }}>SEEN BEFORE</h2>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '100%', maxWidth: '960px' }}>
              <Divider style={{ margin: '1em auto', width: '60px', height: '2px', backgroundColor: '#a72028' }} />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2em', flexWrap: 'wrap' }}>
            {[
              {
                title: '活动一',
                content: 'Phasellus lorem enim, luctus ut velit eget, convallis egestas eros. Sed ornare ligula eget tortor tempor, quis porta tellus dictum.',
                banner: img1
              },
              {
                title: '活动二',
                content: 'Nam ut leo ipsum. Maecenas pretium aliquam feugiat. Aenean vel tempor est, vitae tincidunt risus. Sed sodales vestibulum nibh.',
                banner: img2
              },
              {
                title: '活动三',
                content: 'Vestibulum in dictum velit, in rhoncus nibh. Maecenas neque libero, interdum a dignissim in, aliquet vitae lectus. Phasellus lorem enim, luctus ut velit eget.',
                banner: img3
              },
              {
                title: '活动四',
                content: 'Sed ornare ligula eget tortor tempor, quis porta tellus dictum. Nam ut leo ipsum.',
                banner: img4
              }
            ].map((activity, idx) => (
              <div key={idx} style={{ padding: '1em', width: '100%', maxWidth: '380px' }}>
                <div style={{ marginBottom: '1em', paddingBottom: '99%', position: 'relative', height: 0 }}>
                  <img src={activity.banner} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px', position: 'absolute', top: 0, left: 0 }} />
                </div>
                <h3 style={{ fontWeight: '300' }}>{activity.title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6', fontSize: '0.55rem' }}>{activity.content}</p>
                <Button color='#a72028' textColor='white' style={{ marginTop: '1em' }}>Learn More</Button>
              </div>
            ))}
          </div>
        </section>

        {/* Contact Us Section */}
        <section class='contact-section' style={{ padding: '4em 1em', backgroundColor: '#f5f5f5' }}>
          <h2 style={{ textAlign: 'center', fontWeight: '300' }}>CONTACT US</h2>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '100%', maxWidth: '960px' }}>
              <Divider style={{ margin: '1em auto', width: '60px', height: '2px', backgroundColor: '#a72028' }} />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', marginTop: '2em', flexWrap: 'wrap', gap: '3em' }}>
            {[
              { img: qrcode1, label: '微信公众号' },
              { img: qrcode1, label: '官方社群' },
            ].map((item, idx) => (
              <div key={idx} style={{ textAlign: 'center' }}>
                <div style={{
                  width: '200px',
                  height: '200px',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
                  margin: '0 auto',
                }}>
                  <img src={item.img} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <p style={{ marginTop: '1em', fontSize: '1rem', color: '#555', fontWeight: '300' }}>{item.label}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Footer */}
        <Footer />
      </main>
    )
  }
}
</script>

<style lang='less' scoped>
.home-page {
  overflow-x: hidden;
}
.hero-section {
  background-color: #333;
}
.about-section {
  background-color: white;
}
.what-we-do {
  background-color: #f5f5f5;
}
.stats-section {
  background-color: #333;
}
.seen-before {
  background-color: white;
}
.contact-section {
  background-color: #f5f5f5;
}
</style>